import React from 'react';
import type { FilterButtonsProps } from './types';

export const FilterButtons: React.FC<FilterButtonsProps> = ({
  categories,
  activeFilter,
  onFilterChange,
  textColor,
  filterButtonColor,
  filterButtonActiveColor,
}) => {
  if (categories.length === 0) return null;

  return (
    <div className="flex flex-wrap justify-center gap-2 mb-8">
      <button
        onClick={() => onFilterChange('All')}
        className={`px-4 py-2 rounded-lg transition-colors ${
          activeFilter === 'All' ? 'font-semibold' : 'font-normal'
        }`}
        style={{
          backgroundColor: activeFilter === 'All' ? filterButtonActiveColor : filterButtonColor,
          color: activeFilter === 'All' ? '#ffffff' : textColor,
        }}
      >
        All
      </button>
      {categories.map(category => (
        <button
          key={category}
          onClick={() => onFilterChange(category || 'All')}
          className={`px-4 py-2 rounded-lg transition-colors ${
            activeFilter === category ? 'font-semibold' : 'font-normal'
          }`}
          style={{
            backgroundColor:
              activeFilter === category ? filterButtonActiveColor : filterButtonColor,
            color: activeFilter === category ? '#ffffff' : textColor,
          }}
        >
          {category}
        </button>
      ))}
    </div>
  );
};
